export default __webpack_public_path__ + "static/ai-consultancy-1-b8fffc4276aad68c3fbbdbfb4d52d891.webp";